export default {
  data() {
    return {
      /**
       * @description Оплачиваемые модули.
       * @param {any[]}
       */
      billingInvoiceModules: [],
      /**
       * @description Пакетные модули.
       * @param {any[]}
       */
      billingInvoicePacketModules: [],
      /**
       * @description Оплачиваемые тарифы.
       * @param {any[]}
       */
      billingInvoiceTariffs: [],
      /**
       * @description Ожидание завершения запроса.
       * @param {boolean}
       */
      isBillingInvoiceAwaitRequest: false,
      /**
       * @description Опции выставления счета получены.
       * @param {boolean}
       */
      isBillingInvoiceOptionsLoaded: false,
      /**
       * @description Показывать форму выставления счета.
       * @param {boolean}
       */
      isShowBillingInvoiceForm: false,
      /**
       * @description Выбранные модули.
       * @param {any[]}
       */
      selectedBillingInvoiceModules: [],
      /**
       * @description Выбранные тарифы.
       * @param {any[]}
       */
      selectedBillingInvoiceTariffs: [],
    };
  },
  methods: {
    /**
     * @description Выбрать опции по умолчанию.
     * @returns {void}
     */
    preselectDefaultBillingOptions() {},
    fetchBillingOptions() {
      const onSuccess = (response) => {
        this.billingInvoiceModules = response.modules;
        this.billingInvoiceTariffs = response.tariffs;
        this.billingInvoicePacketModules = response.packet_modules;
        this.preselectDefaultBillingOptions();
        this.isBillingInvoiceOptionsLoaded = true;
        this.isShowBillingInvoiceForm = true;
      };
      return this
        .$tariffGateway
        .viewBillingInvoiceOptions()
        .then((result) => result.forEach(onSuccess));
    },
    closeBillingInvoiceDialogForm() {
      this.isShowBillingInvoiceForm = false;
    },
    downloadBillingInvoice(invoiceId, fileName) {
      const onSuccess = (response) => {
        this.saveFile(response, fileName);
        this.closeBillingInvoiceDialogForm();
      };
      return this
        .$tariffGateway
        .downloadBillingInvoice(invoiceId)
        .then((result) => result.fold(this.notifyFail, onSuccess));
    },
    onDownloadBillingInvoice(request) {
      this.isBillingInvoiceAwaitRequest = true;
      const onSuccess = (response) => this.downloadBillingInvoice(
        response.invoice_id,
        response.file_name,
      );
      this
        .$tariffGateway
        .createBillingInvoice(request)
        .then((result) => result.fold(this.notifyFail, onSuccess))
        .finally(() => { this.isBillingInvoiceAwaitRequest = false; });
    },
    onShowBillingInvoiceForm() {
      if (this.isBillingInvoiceOptionsLoaded) {
        this.preselectDefaultBillingOptions();
        this.isShowBillingInvoiceForm = true;
        return;
      }
      this.isBillingInvoiceAwaitRequest = true;
      this
        .fetchBillingOptions()
        .finally(() => { this.isBillingInvoiceAwaitRequest = false; });
    },
  },
};
